import * as o from "react";
import r from "../lib/SSRBase.es.js";
import t from "../defs/ShoppingBag.es.js";
const a = o.forwardRef((p, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...p, weights: t }));
a.displayName = "ShoppingBagIcon";
const n = a;
export {
  n as ShoppingBag,
  a as ShoppingBagIcon
};
